module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-x-100298cf.svg";